import { z } from 'zod';

import { CollectionSchema } from './collections';
import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { SourceSchema } from './sources';
import { TextContentSchema } from './text-contents';
import { commaDelimitedList } from './utils';

export const TextChunkSchema = z.object({
  textChunkId: z.string().nanoid(),
  textContentId: TextContentSchema.shape.textContentId,
  content: z.string(),
  relativePosition: z.number().min(0),
  createdAt: z.coerce.date(),
});

export type TextChunk = z.infer<typeof TextChunkSchema>;

export const TextChunksSchema = z.array(TextChunkSchema);

export type TextChunks = z.infer<typeof TextChunksSchema>;

export const TextChunksQuerySchema = z
  .object({
    textChunkIds: commaDelimitedList(
      TextChunkSchema.shape.textChunkId.array(),
    ).optional(),
    textContentIds: commaDelimitedList(
      TextContentSchema.shape.textContentId.array(),
    ).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['created_at'])));

export type TextChunksQuery = z.infer<typeof TextChunksQuerySchema>;

export const TextChunkSearchResultSchema = z.object({
  textChunkId: TextChunkSchema.shape.textChunkId,
  score: z.number(),
});

export type TextChunkSearchResult = z.infer<typeof TextChunkSearchResultSchema>;

export const TextChunkSearchQuerySchema = z.object({
  query: z.string(),
  limit: z.coerce.number().default(100).optional(),
  collectionIds: commaDelimitedList(
    CollectionSchema.shape.collectionId.array(),
  ).optional(),
  sourceIds: commaDelimitedList(SourceSchema.shape.sourceId.array()).optional(),
});

export type TextChunkSearchQuery = z.infer<typeof TextChunkSearchQuerySchema>;
